<template>
  <div></div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('system', ['routerStatusRedirect']),
    ...mapGetters('signup', ['signUpErrorRecordsPending']),
  },
  async created() {
    await this.getUsersSignUpErrorRecords()
    if (this.signUpErrorRecordsPending) {
      const path = '/signup/problem'
      if ([path].includes(this.$route.path) === false) {
        await this.$router.replace(path)
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('signup', ['getUsersSignUpErrorRecords']),
  },
}
</script>
